export const WIDGET_APPEARANCE_SETTINGS_TYPE = 'appearance'
export const WIDGET_POPUP_SETTINGS_TYPE = 'popup'
export const WIDGET_PLACEMENT_SETTINGS_TYPE = 'placement'